import { integrationsConstants } from "./integrations.constants";

export function integration(state = {}, action) {
    let index;
    let employees;
    let changedEmployee;
    let leavingEmployee;
    let date;
    let timestamp;
    switch (action.type) {
        // BAMBOO
        case integrationsConstants.GET_BAMBOO_INTEGRATIONS_REQUEST:
            return {
                loading: true,
                items: null,
            };

        case integrationsConstants.GET_BAMBOO_INTEGRATIONS_SUCCESS:
            return {
                items: action.result,
            };

        case integrationsConstants.GET_BAMBOO_INTEGRATIONS_FAILURE:
            return {
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.ADD_BAMBOO_INTEGRATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case integrationsConstants.ADD_BAMBOO_INTEGRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                addModal: false,
                items: [...state.items, action.result],
            };
        case integrationsConstants.ADD_BAMBOO_INTEGRATION_FAILURE:
            return {
                ...state,
                loading: false,
                addModal: true,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.TOGGLE_NEW_INTEGRATION_MODAL:
            return {
                ...state,
                addModal: !state.addModal,
            };

        case integrationsConstants.TOGGLE_DELETE_BAMBOO_INTEGRATION:
            return {
                ...state,
                bambooConfigurationToDelete: action.configuration,
                bambooDeletionModal: !state.bambooDeletionModal,
                bambooDeletionErrorMessage: null,
            };

        case integrationsConstants.DELETE_BAMBOO_INTEGRATION_REQUEST:
            return {
                ...state,
                deletionLoading: true,
                bambooDeletionErrorMessage: null,
            };

        case integrationsConstants.DELETE_BAMBOO_INTEGRATION_SUCCESS:
            let oldItems = state.items;
            if (action.result && action.result.externalUUID) {
                index = oldItems.findIndex((item) => {
                    return action.result.externalUUID === item.externalUUID;
                });
                if (index > -1) {
                    oldItems.splice(index, 1);
                }
            }
            return {
                ...state,
                bambooConfigurationToDelete: null,
                bambooDeletionModal: false,
                deletionLoading: false,
                items: oldItems,
            };

        case integrationsConstants.DELETE_BAMBOO_INTEGRATION_FAILURE:
            return {
                ...state,
                deleteModal: true,
                deletionLoading: false,
                bambooDeletionErrorMessage: action.errorMessage,
            };
        case integrationsConstants.TOGGLE_BAMBOO_RESULT_OPTIONS:
            return {
                ...state,
                showResultOptionsModal: !state.showResultOptionsModal,
            };
        case integrationsConstants.RECEIVE_BAMBOO_RESULT_OPTIONS_REQUEST:
            return {
                ...state,
                loadingOptions: true,
                showResultOptionsModal: true,
                resultOptionsId: action.integrationId,
                bambooResultOptions: action.result,
            };
        case integrationsConstants.RECEIVE_BAMBOO_RESULT_OPTIONS_SUCCESS:
            return {
                ...state,
                loadingOptions: false,
                showResultOptionsModal: true,
                bambooResultOptions: action.result,
            };
        case integrationsConstants.RECEIVE_BAMBOO_RESULT_OPTIONS_FAILURE:
            return {
                ...state,
                loadingOptions: false,
                showResultOptionsModal: false,
                bambooResultOptions: action.result,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.RETRIEVE_BAMBOO_RESULT_REQUEST:
            return {
                ...state,
                loadingResult: true,
                showResultOptionsModal: true,
                errorMessage: null,
            };
        case integrationsConstants.RETRIEVE_BAMBOO_RESULT_SUCCESS:
            return {
                ...state,
                loadingResult: false,
                showResultOptionsModal: false,
                bambooReportData: action.result,
                beginDate: action.beginDate,
                endDate: action.endDate,
            };
        case integrationsConstants.RETRIEVE_BAMBOO_RESULT_FAILURE:
            return {
                ...state,
                loadingResult: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.SAVE_BAMBOO_CONFIGURATION_REQUEST:
            return {
                ...state,
                loadingResult: true,
            };
        case integrationsConstants.SAVE_BAMBOO_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loadingResult: false,
            };
        case integrationsConstants.SAVE_BAMBOO_CONFIGURATION_FAILURE:
            return {
                ...state,
                loadingResult: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case integrationsConstants.TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS:
            const itemDatevData = {
                externalUUID: action.item.externalUUID,
                bambooFieldsWithoutDatevMapping: action.item.bambooFieldsWithoutDatevMapping,
                bambooFieldsDatevMapping: action.item.bambooFieldsDatevMapping,
                availableDatevFields: action.item.availableDatevFields,
            };
            return {
                ...state,
                loading: false,
                datevData: itemDatevData,
            };

        case integrationsConstants.SAVE_BAMBOO_DATEV_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };

        case integrationsConstants.SAVE_BAMBOO_DATEV_SETTINGS_SUCCESS:
            return {
                ...state,
                loadingResult: false,
                loading: false,
            };
        case integrationsConstants.SAVE_BAMBOO_DATEV_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.TRANSFER_BAMBOO_TO_HR_REPORT_REQUEST:
            return {
                ...state,
                errorMessage: null,
                loading: true,
            };

        case integrationsConstants.TRANSFER_BAMBOO_TO_HR_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                hrReportData: action.result,
            };
        case integrationsConstants.TRANSFER_BAMBOO_TO_HR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.CONFIRM_HR_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case integrationsConstants.CONFIRM_HR_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                hrReportData: action.result,
            };
        case integrationsConstants.CONFIRM_HR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.GET_HR_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };

        case integrationsConstants.GET_HR_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                hrReportData: action.result,
            };
        case integrationsConstants.GET_HR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };
        case "TOGGLE_HR_REPORT_MANUAL_CHANGE":
            return {
                ...state,
                manualChangeModal: !state.manualChangeModal,
            };

        case "ADD_COMMENT_TO_HR_REPORT_ITEM":
            date = new Date();
            timestamp = date.getTime();
            if (!action.item.comments) {
                action.employee.comments = [];
            }
            action.item.comments.push({
                user: action.currentUser.firstName + " " + action.currentUser.lastName,
                comment: "",
                timeStamp: timestamp,
                isTransient: true,
            });
            return {
                ...state,
            };
        case "DISCARD_COMMENT_FROM_HR_REPORT_ITEM":
            if (action.item.comments) {
                action.item.comments.splice(action.index, 1);
            }
            return {
                ...state,
                commentErrorMessage: null,
            };
        case "UPDATE_COMMENT_ON_HR_REPORT_ITEM":
            action.comment.comment = action.value;
            return {
                ...state,
            };
        case "UPDATE_ACTUAL_HOURS_ON_HR_REPORT_ITEM":
            if (action.updateType === "hours") {
                action.employee.hours = action.newValue;
            }
            if (action.updateType === "minutes") {
                action.employee.minutes = action.newValue;
            }
            return {
                ...state,
            };
        case "ADD_COMMENT_TO_HR_REPORT":
            date = new Date();
            timestamp = date.getTime();

            if (!action.reportData.customComments) {
                action.reportData.customComments = [];
            }
            action.reportData.customComments.push({
                user: action.currentUser.firstName + " " + action.currentUser.lastName,
                comment: "",
                timeStamp: timestamp,
                isTransient: true,
            });
            return {
                ...state,
            };

        case "DISCARD_REPORT_COMMENT":
            if (action.reportData.customComments) {
                action.reportData.customComments.splice(action.index, 1);
            }
            return {
                ...state,
            };

        case integrationsConstants.SAVE_COMMENT_ON_CHANGE_REQUEST:
            return {
                ...state,
                savingComment: true,
                commentErrorMessage: null,
            };

        case integrationsConstants.SAVE_COMMENT_ON_CHANGE_SUCCESS:
            action.comment.isTransient = false;
            action.comment.userName = action.result.userName;
            action.comment.formattedDateTime = action.result.formattedDateTime;
            action.comment.attachedFileName = action.result.attachedFileName;
            action.comment.attachmentFileDownloadURL = action.result.attachmentFileDownloadURL;
            action.comment.id = action.result.id;
            return {
                ...state,
                savingComment: false,
                commentErrorMessage: null,
            };

        case integrationsConstants.SAVE_COMMENT_ON_CHANGE_FAILURE:
            return {
                ...state,
                savingComment: false,
                commentErrorMessage: action.errorMessage,
            };

        case integrationsConstants.CHANGE_STATUS_ON_CHANGE_REQUEST:
            return {
                ...state,
                savingStatus: true,
                savingStatusExternalUUID: action.item.externalUUID,
                commentErrorMessage: null,
            };

        case integrationsConstants.CHANGE_STATUS_ON_CHANGE_SUCCESS:
            action.item.processingStatus = action.newStatus;
            if (!action.item.comments) {
                action.item.comments = [];
            }
            action.item.comments.push({
                userName: action.newComment.userName,
                comment: action.newComment.comment,
                formattedDateTime: action.newComment.formattedDateTime,
                isTransient: false,
            });

            action.item.actualHours = action.actualHours;
            action.item.actualPayment = action.actualPayment;

            return {
                ...state,
                savingStatus: false,
                savingStatusExternalUUID: null,
                commentErrorMessage: null,
            };

        case integrationsConstants.CHANGE_STATUS_ON_CHANGE_FAILURE:
            return {
                ...state,
                savingStatus: false,
                savingStatusExternalUUID: null,
                commentErrorMessage: action.errorMessage,
            };

        case integrationsConstants.SAVE_MANUAL_CHANGE_ON_HR_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                manualChangeErrorMessages: null,
            };

        case integrationsConstants.SAVE_MANUAL_CHANGE_ON_HR_REPORT_SUCCESS:
            const { hrReportData } = state;
            hrReportData.changedEmployees.unshift(action.result);

            return {
                ...state,
                loading: false,
                manualChangeModal: false,
                manualChangeErrorMessages: null,
                hrReportData: hrReportData,
            };

        case integrationsConstants.SAVE_MANUAL_CHANGE_ON_HR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                manualChangeErrorMessages: action.errorMessage,
            };

        case integrationsConstants.APPROVE_ALL_CHANGES_ON_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                loadingResult: true,
                errorMessage: null,
                savingApproval: true,
            };
        case integrationsConstants.APPROVE_ALL_CHANGES_ON_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                hrReportData: action.result,
                errorMessage: null,
                savingApproval: false,
            };
        case integrationsConstants.APPROVE_ALL_CHANGES_ON_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                errorMessage: action.errorMessage,
                savingApproval: false,
            };

        case integrationsConstants.GET_HR_REPORTS_REQUEST:
            return {
                loading: true,
                loadingResult: false,
                commentErrorMessage: null,
                savingComment: false,
                hrReports: null,
                filterProperties: action.filterProperties,
            };
        case integrationsConstants.GET_HR_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                hrReports: action.hrReports,
                commentErrorMessage: null,
            };
        case integrationsConstants.GET_HR_REPORTS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingResult: false,
            };

        case integrationsConstants.DELETE_HR_REPORT_REQUEST:
            return {
                loading: true,
                loadingResult: false,
                showHRReportDeleteModal: true,
            };

        case integrationsConstants.DELETE_HR_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                showHRReportDeleteModal: false,
            };

        case integrationsConstants.DELETE_HR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                loadingResult: false,
                errorMessage: action.errorMessage,
                showHRReportDeleteModal: true,
            };

        case integrationsConstants.TOGGLE_HR_REPORT_DELETE_MODAL:
            return {
                ...state,
                showHRReportDeleteModal: !state.showHRReportDeleteModal,
            };

        case integrationsConstants.GET_SEARCH_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case integrationsConstants.GET_SEARCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                searchData: action.result,
            };

        case integrationsConstants.GET_SEARCH_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.CLOSE_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case integrationsConstants.CLOSE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case integrationsConstants.CLOSE_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_REQUEST:
            return {
                ...state,
                subloading: true,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_SUCCESS:
            return {
                ...state,
                subloading: false,
                hrReportData: {
                    ...state.hrReportData,
                    customComments: action.response,
                },
                errorMessage: null,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_FROM_ITEM_REQUEST:
            return {
                ...state,
                subloading: true,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_FROM_ITEM_SUCCESS:
            return {
                ...state,
                subloading: false,
                errorMessage: null,
            };

        case integrationsConstants.DELETE_HR_CHANGE_COMMENT_FROM_ITEM_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.DELETE_CHANGED_FIELD_REQUEST:
            return {
                ...state,
                subloading: true,
            };

        case integrationsConstants.DELETE_CHANGED_FIELD_SUCCESS:
            employees = state.hrReportData.changedEmployees;
            changedEmployee = action.result;

            index = employees.findIndex((item) => {
                return item.externalUUID === changedEmployee.externalUUID;
            });

            if (changedEmployee.changedFields.length > 0 || changedEmployee.comments.length > 0) {
                employees[index] = changedEmployee;
            } else {
                employees.splice(index, 1);
            }

            return {
                ...state,
                hrReportData: {
                    ...state.hrReportData,
                    changedEmployees: employees,
                },
                errorMessage: null,
                subloading: false,
            };

        case integrationsConstants.DELETE_CHANGED_FIELD_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.DELETE_CHANGE_REQUEST:
            return {
                ...state,
                subloading: true,
            };

        case integrationsConstants.DELETE_CHANGE_SUCCESS:
            employees = state.hrReportData.changedEmployees;
            changedEmployee = action.result;

            index = employees.findIndex((item) => {
                return item.externalUUID === changedEmployee.externalUUID;
            });

            if (index >= 0) {
                employees.splice(index, 1);
                return {
                    ...state,
                    hrReportData: {
                        ...state.hrReportData,
                        changedEmployees: employees,
                    },
                    errorMessage: null,
                    subloading: false,
                };
            } else {
                employees = state.hrReportData.absentEmployees;
                changedEmployee = action.result;

                index = employees.findIndex((item) => {
                    return item.externalUUID === changedEmployee.externalUUID;
                });

                if (index >= 0) {
                    employees.splice(index, 1);
                    return {
                        ...state,
                        hrReportData: {
                            ...state.hrReportData,
                            absentEmployees: employees,
                        },
                        errorMessage: null,
                        subloading: false,
                    };
                } else {
                    return {
                        ...state,
                        errorMessage: "Ein unbekannter Fehler ist aufgetreten",
                        subloading: false,
                    };
                }
            }

        case integrationsConstants.DELETE_CHANGE_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
            };

        case integrationsConstants.DELETE_LEAVING_EMPLOYEE_REQUEST:
            return {
                ...state,
                subloading: true,
            };

        case integrationsConstants.DELETE_LEAVING_EMPLOYEE_SUCCESS:
            employees = state.hrReportData.leavingEmployees;
            leavingEmployee = action.result;

            index = employees.findIndex((item) => {
                return item.externalUUID === leavingEmployee.externalUUID;
            });

            if (index >= 0) {
                employees.splice(index, 1);
                return {
                    ...state,
                    hrReportData: {
                        ...state.hrReportData,
                        leavingEmployees: employees,
                    },
                    errorMessage: null,
                    subloading: false,
                };
            } else {
                return {
                    ...state,
                    errorMessage: "Ein unbekannter Fehler ist aufgetreten",
                    subloading: false,
                };
            }

        case integrationsConstants.DELETE_LEAVING_EMPLOYEE_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
            };

        default:
            return state;
    }
}
